const cookieBotLinks = () => {
	document.querySelectorAll('.cookie-preferences').forEach((element) => {
		element.addEventListener('click', (e) => {
			if (window.Cookiebot && typeof window.Cookiebot.show === 'function') {
				e.preventDefault();
				e.stopPropagation();
				window.Cookiebot.show();
			}
		});
	});
};

export default cookieBotLinks;